const removeLabelsData = (product) => ({
  ...product,
  badgeType: null,
  isSellingFast: false,
  hasMoreColours: false,
});

export default removeLabelsData;
